<template>
    <div>
        
        <div class="container">
         <Cabecera></Cabecera> 
         <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/iniciarSesion">Iniciar Sesión </router-link></b-breadcrumb-item>
     </b-breadcrumb>
<div class="row">
    
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Iniciar Sesión</span>
          <form id="inicioSesion" autocomplete="off" @submit.prevent="login" enctype="multipart/form-data">
            <input type="email" name="email" placeholder="Correo Electrónico" required>
            <input type="password" name="pass" placeholder="Password" required pattern="[A-Za-z0-9]{8,15}">
            <input type="submit" value="Entrar" class="btn btn-large blue">
            </form>
        </div>
        <div class="card-action">
          
         
        </div>
      </div>
    </div>
  </div>

</div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import Cabecera from './Cabecera'
import {mapState, mapMutations} from 'vuex'

export default {
  name: 'iniciarSesion',
  components:{
    Cabecera
  },
  computed:{
    //  ...mapState(['usuario'])
  },
  methods:{
      ...mapMutations(['LLENAR_USUARIO']),
    login(){
            const form=document.getElementById('inicioSesion')
                axios.post('https://micomidasegura.mx/comidaSegura/api/loginRegistro/login.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data.res == 'success') {
                    this.$localStorage.set('token',JSON.stringify(res.data.token))
                    //this.$localStorage.set('usuario',JSON.stringify(res.data.usuario))
                    //this.$localStorage.set('email',JSON.stringify(res.data.email))
                    
                    //this.$store.commit('GET_USUARIO',res.data.usuario)
                    //this.$store.commit('GET_ID',res.data.id)
                    //this.$store.commit('GET_FOTO',res.data.foto)
                     //this.$localStorage.set('token',JSON.stringify(res.data))
                        this.$router.push('/menuinicial')
                    } else {
                        swal('Usuario y/o contraseña incorrecto')
                    }
                })
        } ,
       
  created(){
    const token = JSON.parse(this.$localStorage.get('token'))
    if (token) {
      this.$router.push('/menuinicial')
    }
  }
}}
</script>



// WEBPACK FOOTER //
// src/components/iniciarSesion.vue